import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarStatusApprovedExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" status="approved" />;
};

export default AvatarStatusApprovedExample;
